import { Popup, Text } from 'platform-components';
import { POPUP_DIRECTIONS, POPUP_THEMES, POPUP_AXIS } from 'platform-components/constants';
import React, { useEffect, useRef } from 'react';

import './results__header-cell-description.scss';

interface OwnProps {
    owner?: HTMLDivElement | null;
    showPopup: boolean;
}

interface Props extends OwnProps {}

const OFFSET_TOP = -44;

export const ResultHeaderCellDescription = ({ owner, showPopup }: Props) => {
    const popupRef = useRef<Popup>(null);

    useEffect(() => {
        if (showPopup) {
            popupRef.current?.show();
        } else {
            popupRef.current?.hide();
        }
    }, [showPopup]);

    useEffect(() => {
        popupRef.current?.setOwner(owner);
    }, [owner]);

    return (
        <Popup
            axis={POPUP_AXIS.CENTER}
            direction={POPUP_DIRECTIONS.TOP}
            fitToScreen
            hasArrow
            inLayer
            mix="results__header-cell-description-popup"
            offsetTop={OFFSET_TOP}
            ref={popupRef}
            selfclosable
            theme={POPUP_THEMES.DARK}
        >
            <Text id="lessonView.results.problemsCanNotBeShown.popup" />
        </Popup>
    );
};
